<div class="page-wrapper bg-light min-vh-100 py-4">
  <div class="container-fluid px-md-5">
    <h2 class="mb-4 text-center fw-bold text-primary">
      <i class="fas fa-home"></i> Agregar Propiedad
    </h2>

    <app-loading *ngIf="loading"></app-loading>
    <app-alert *ngIf="mensajeErrorIA"></app-alert>

    <form (ngSubmit)="CrearPropiedad(f)" #f="ngForm">

      <div class="row g-4">
        <!-- 🏠 Domicilio -->
        <div class="col-lg-6 col-12">
          <section class="form-section h-100">
            <h5>Domicilio</h5>
            <div class="row g-3">
              <div class="col-md-4 col-12">
                <div class="form-floating">
                  <select class="form-select" id="localidad" name="localidad" ngModel required>
                    <option *ngFor="let l of localidades" [ngValue]="l.id">{{ l.descripcion }}</option>
                  </select>
                  <label for="localidad">Localidad</label>
                </div>
              </div>
              <div class="col-md-8 col-12">
                <div class="form-floating">
                  <input type="text" id="calle" name="calle" class="form-control" placeholder="Calle"
                    [(ngModel)]="direccion.calle" required>
                  <label for="calle">Calle</label>
                </div>
              </div>
              <div class="col-md-4 col-6">
                <div class="form-floating">
                  <input type="text" id="numero" name="numero" class="form-control" placeholder="Número"
                    [(ngModel)]="direccion.numero" required>
                  <label for="numero">Número</label>
                </div>
              </div>
              <div class="col-md-4 col-6">
                <div class="form-floating">
                  <input type="text" id="piso" name="piso" [(ngModel)]="direccion.piso" class="form-control"
                    placeholder="Piso">
                  <label for="piso">Piso</label>
                </div>
              </div>
              <div class="col-md-4 col-12">
                <div class="form-floating">
                  <input type="text" id="depto" name="depto" [(ngModel)]="direccion.depto" class="form-control"
                    placeholder="Depto">
                  <label for="depto">Depto</label>
                </div>
              </div>
              <div class="col-12">
                <div class="form-floating">
                  <input type="text" id="callesEntre" name="callesEntre" [(ngModel)]="direccion.callesEntre"
                    class="form-control" placeholder="Entre calles">
                  <label for="callesEntre">Entre calles</label>
                </div>
              </div>
            </div>

            <div class="mt-3">
              <h6>Ubicación en mapa</h6>
              <app-map-picker [direccion]="direccion" [lat]="direccion.lat" [lng]="direccion.lng"
                (locationSelected)="updateLatLng($event)">
              </app-map-picker>
            </div>
          </section>
        </div>

        <!-- 📝 Datos básicos -->
        <div class="col-lg-6 col-12">
          <section class="form-section h-100">
            <h5>Datos básicos</h5>
            <div class="row g-3">
              <div class="col-md-6 col-12">
                <div class="form-floating">
                  <select class="form-select" id="tipoOp" name="tipoOp" ngModel>
                    <option *ngFor="let tipoOp of tipoOperaciones" [ngValue]="tipoOp.id">{{ tipoOp.descripcion }}
                    </option>
                  </select>
                  <label for="tipoOp">Operación</label>
                </div>
              </div>
              <div class="col-md-6 col-12">
                <div class="form-floating">
                  <select class="form-select" id="tipoPro" name="tipoPro" ngModel>
                    <option *ngFor="let tipoPro of tipoPropiedades" [ngValue]="tipoPro.id">{{ tipoPro.descripcion }}
                    </option>
                  </select>
                  <label for="tipoPro">Tipo propiedad</label>
                </div>
              </div>
              <div class="col-md-6 col-6">
                <div class="form-floating">
                  <select class="form-select" id="tipoMoneda" name="tipoMoneda" ngModel>
                    <option *ngFor="let tipoM of tipoMonedas" [ngValue]="tipoM.id">{{ tipoM.code }}</option>
                  </select>
                  <label for="tipoMoneda">Moneda</label>
                </div>
              </div>
              <div class="col-md-6 col-6">
                <div class="form-floating">
                  <input type="number" id="precio" name="precio" [(ngModel)]="propiedad.precio" class="form-control"
                    placeholder="Precio" required>
                  <label for="precio">Precio</label>
                </div>
              </div>
              <div class="col-12">
                <div class="form-floating">
                  <textarea id="infoInterna" name="infoInterna" [(ngModel)]="propiedad.infoInterna" class="form-control"
                    placeholder="Información interna" style="height:80px"></textarea>
                  <label for="infoInterna">Información Interna</label>
                </div>
              </div>

              <div class="col-12">
                <div class="form-floating">
                  <input type="url" id="videoUrl" name="videoUrl" [(ngModel)]="propiedad.videoUrl" class="form-control"
                    placeholder="https://www.tiktok.com/@usuario/video/1234567890">
                  <label for="videoUrl">Video TikTok / Instagram / YouTube</label>
                </div>
                <small class="form-text text-muted">
                  Pegá aquí el enlace del video (TikTok, Instagram o YouTube).
                </small>
              </div>
            </div>
          </section>


        </div>
      </div>

      <!-- ⚙️ Características + ✨ Descripción -->
      <div class="row g-4 mt-2">
        <div class="col-lg-6 col-12">
          <section class="form-section h-100">
            <h5 class="d-flex justify-content-between align-items-center">
              Características
              <button type="button" class="btn btn-sm btn-outline-primary" (click)="addCaractetistica()">
                <i class="fas fa-plus"></i> Agregar
              </button>
            </h5>
            <div class="caracteristicas-scroll" *ngIf="productFormGroupCarct">
              <div [formGroup]="caracteristica"
                *ngFor="let caracteristica of productFormGroupCarct.controls; let i = index"
                class="row g-2 mb-2 align-items-center caracteristica-row">
                <div class="col-12 col-md-6">
                  <select class="form-select" formControlName="caractPropId">
                    <option *ngFor="let c of caracteristicasPropiedad" [ngValue]="c.id">{{ c.descripcion }}</option>
                  </select>
                </div>
                <div class="col-10 col-md-5">
                  <input type="text" formControlName="caractPropValor" class="form-control" placeholder="Valor">
                </div>
                <div class="col-2 col-md-1 text-end">
                  <button type="button" class="btn btn-sm btn-outline-danger" (click)="deleteCaractetistica(i)">
                    <i class="fas fa-minus-circle"></i>
                  </button>
                </div>
              </div>
            </div>
          </section>
        </div>

        <div class="col-lg-6 col-12">
          <section class="form-section h-100">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <h5 class="mb-0">Descripción</h5>
              <button type="button" class="btn btn-info btn-sm" (click)="confirmarIA(f)">
                <i class="fas fa-robot"></i> Generar con IA
              </button>
            </div>
            <div class="row g-3">
              <div class="col-12">
                <div class="form-floating">
                  <textarea id="descripcionCorta" name="descripcionCorta" [(ngModel)]="propiedad.descripcionCorta"
                    class="form-control" placeholder="Descripción corta" style="height:100px"></textarea>
                  <label for="descripcionCorta">Descripción corta</label>
                </div>
              </div>
              <div class="col-12">
                <div class="form-floating">
                  <textarea id="descripcionLarga" name="descripcionLarga" [(ngModel)]="propiedad.descripcionLarga"
                    class="form-control" placeholder="Descripción larga" style="height:120px"></textarea>
                  <label for="descripcionLarga">Descripción larga</label>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      <!-- Botones -->
      <div class="form-actions text-center mt-4">
        <button type="button" class="btn btn-outline-secondary me-2" (click)="back()">Cancelar</button>
        <button type="submit" class="btn btn-primary px-4">Guardar</button>
      </div>
    </form>
  </div>
</div>